<template>
    <v-container fluid style="min-height:100vh">
        <v-row  class="ma-auto">
            <v-col>
                <a href="/"><v-icon>mdi-arrow-left</v-icon><span class="justify-center"> Back to home</span></a>
            </v-col>
        </v-row >
        <v-row>
            <v-col>
                <v-container class="newsbody">
                    <h1 v-html="title"></h1>
        <v-row v-if="date != null">
            <v-col cols="12" lg="3" md="3" sm="12" xs="12">
                <p v-if="$vuetify.breakpoint.smAndDown" class="mb-3 text-right" style="font-size:0.75rem"><i>Posted on
                        {{ date | moment('DD/MM/YYYY') }}</i></p>
                <v-img :src="image" max-height=500 :class="{ 'img-mobile': $vuetify.breakpoint.smAndDown }" contain></v-img>
            </v-col>
            <v-col cols="12" lg="3" md="3" sm="12" xs="12">
                <v-row>
                    <v-col>
                        <div v-html="content" style="margin-bottom: 10%;"></div>
                        <p v-if="!$vuetify.breakpoint.smAndDown" class="mt-4 text-right" style="font-size:0.75rem"><i>Posted
                                on {{ date | moment('DD/MM/YYYY') }}</i></p>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
export default {
    name: 'Post',
    data () {
        return {
            title: '',
            content: null,
            date: null,
            image: ''

        }
    },
    beforeRouteEnter: (to, from, next) => {
        next(vm => {
            vm.$store.dispatch('setLoading', {variable: 'post', value: true}).then(() => {
            vm.$axios.get(vm.$posts + vm.$route.params.id).then(response => {
                vm.title = response.data[0].title.rendered
                vm.content = response.data[0].content.rendered
                vm.date = response.data[0].date
                vm.image = response.data[0].jetpack_featured_media_url
                window.document.title = 'Fred Dope | ' + vm.title.replace('&#038;', '&').replace('&#8211;', '-');
                const metaTitle = document.querySelector('head meta[property="og:title"]');
                metaTitle.setAttribute('content', 'Fred Dope | ' + vm.title.replace('&#038;', '&').replace('&#8211;', '-'));
                const metaImage = document.querySelector('head meta[property="og:image"]');
                metaImage.setAttribute('content', response.data[0].jetpack_featured_media_url);
                const metaUrl = document.querySelector('head meta[property="og:url"]');
                metaUrl.setAttribute('content', 'https://www.freddope.com/post/' + vm.$route.params.id);
                vm.$store.dispatch('setLoading', {variable: 'post', value: false})
        }).catch((error) => console.log(error))
            })
    })
   }
}
</script>
<style>
.newsbody {
    min-height: 100vh;
    font-size: 2vh;

}</style>
